import React, {useState} from 'react'
import useProductUsageHistoryStyles from 'pages/ProductUsageHistory/style'
import {OFFER_TYPE, PAYMENT_METHOD} from 'pages/ProductsPages/constant'
import {ListLicenses} from 'api/productApi'
import useProductUsageHistory from 'features/productUsageHistory/useProductUsageHistory'
import useProductInstitutionOperationHistory from 'features/productInstitutionOperationHistory/useProductInstitutionOperationHistory'
import RechargeableBulkProduct from 'pages/ProductUsageHistory/Component/Component/RechargeableBulkProduct'
import ManualPaymentProduct from 'pages/ProductUsageHistory/Component/Component/ManualPaymentProduct'
import RechargeableMonthly from './Component/RechargeableMonthly'
import CardInfo from './Component/CardInfo'

type ActiveProductProps = {
  data: ListLicenses[]
  isAdmin?: boolean
  orgName?: string
  onUpdateLog: () => void
}

const NotActiveProduct = ({
  data,
  isAdmin = false,
  orgName = '',
  onUpdateLog,
}: ActiveProductProps) => {
  const classes = useProductUsageHistoryStyles()
  const [productType, setProductType] = useState<string>('')
  const [offerType, setOfferType] = useState<string>('')
  const [selectCard, setSelectCard] = useState<string>('')
  const [itemInfo, setItemInfo] = useState<ListLicenses | null>(null)
  const [listItem, setListItem] = useState<ListLicenses['items'] | []>([])
  const {onSearchLicenseWithId} = useProductInstitutionOperationHistory()
  const {onSearchLicenseLogsWithId} = useProductUsageHistory()

  const handleClick = ({
    item,
    paymentMethod,
    offerType,
  }: {
    item: ListLicenses['items']
    paymentMethod: string
    offerType: string
  }) => {
    setProductType(paymentMethod)
    setOfferType(offerType)
    setListItem(item)
  }

  return (
    <div>
      <div className={classes.productsGrid}>
        {[...data]
          .sort((a, b) => b.activationDateTime - a.activationDateTime)
          .map((item) => (
            <div key={item.id}>
              {item && (
                <CardInfo
                  id={item.goodsId}
                  item={item.items}
                  active={selectCard === item.id}
                  onActive={() => setSelectCard(item.id)}
                  handleClick={(args) => {
                    handleClick(args)
                    setItemInfo(item)
                    if (isAdmin) {
                      onSearchLicenseWithId(item.id)
                    } else {
                      onSearchLicenseLogsWithId(item.id)
                    }
                  }}
                  periodDate={{
                    startDate: item.activationDateTime,
                    endDate: item.deactivationDateTime,
                  }}
                  isAdmin={isAdmin}
                />
              )}
            </div>
          ))}
      </div>

      {productType === PAYMENT_METHOD.PREPAYMENT &&
        offerType === OFFER_TYPE.MONTHLY && (
          <RechargeableMonthly
            item={itemInfo}
            isAdmin={isAdmin}
            orgName={orgName}
            onUpdateLog={onUpdateLog}
          />
        )}
      {productType === PAYMENT_METHOD.PREPAYMENT &&
        offerType === OFFER_TYPE.ONCE && (
          <RechargeableBulkProduct
            listItem={listItem}
            item={itemInfo}
            isAdmin={isAdmin}
            orgName={orgName}
            onUpdateLog={onUpdateLog}
          />
        )}
      {productType === PAYMENT_METHOD.MANUAL && (
        <ManualPaymentProduct item={itemInfo} isAdmin={isAdmin} />
      )}
    </div>
  )
}

export default NotActiveProduct
